
import React, { useEffect } from 'react';

interface PolicyModalProps {
  type: 'agreement' | 'privacy';
  onClose: () => void;
}

const PolicyModal: React.FC<PolicyModalProps> = ({ type, onClose }) => {
  // 모달이 열릴 때 스크롤 방지
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  const title = type === 'agreement' ? '서비스 이용약관' : '개인정보 처리방침';
  
  const agreementContent = `
    <div class="space-y-6 text-gray-600 text-sm leading-relaxed">
      <div>
        <h4 class="font-bold text-gray-900 text-base mb-2">제1조(목적)</h4>
        <p class="mb-1 text-xs font-bold text-gray-500">표준약관 제10023호</p>
        <p>이 약관은 메이커스토리(전자거래 사업자)가 운영하는 쇼핑몰 사이버 몰(이하 "몰"이라 한다)에서 제공하는 인터넷 관련 서비스(이하 "서비스"라 한다)를 이용함에 있어 사이버몰과 이용자의 권리·의무 및 책임사항을 규정함을 목적으로 합니다.</p>
        <p class="text-xs text-gray-400 mt-1">※ 「PC통신등을 이용하는 전자거래에 대해서도 그 성질에 반하지 않는한 이 약관을 준용합니다」</p>
      </div>

      <div>
        <h4 class="font-bold text-gray-900 text-base mb-2">제2조(정의)</h4>
        <p>① "몰"이란 메이커스토리 회사가 재화 또는 용역을 이용자에게 제공하기 위하여 컴퓨터등 정보통신설비를 이용하여 재화 또는 용역을 거래할 수 있도록 설정한 가상의 영업장을 말하며, 아울러 사이버몰을 운영하는 사업자의 의미로도 사용합니다.</p>
        <p>② "이용자"란 "몰"에 접속하여 이 약관에 따라 "몰"이 제공하는 서비스를 받는 회원 및 비회원을 말합니다.</p>
        <p>③ ‘회원’이라 함은 "몰"에 개인정보를 제공하여 회원등록을 한 자로서, "몰"의 정보를 지속적으로 제공받으며, "몰"이 제공하는 서비스를 계속적으로 이용할 수 있는 자를 말합니다.</p>
        <p>④ ‘비회원’이라 함은 회원에 가입하지 않고 "몰"이 제공하는 서비스를 이용하는 자를 말합니다.</p>
      </div>

      <div>
        <h4 class="font-bold text-gray-900 text-base mb-2">제3조(약관등의 명시와 설명 및 개정)</h4>
        <p>① "몰"은 이 약관의 내용과 상호 및 대표자 성명, 영업소 소재지 주소(소비자의 불만을 처리할 수 있는 곳의 주소를 포함), 전화번호·모사전송번호·전자우편주소, 사업자등록번호, 통신판매업신고번호, 개인정보 보호책임자등을 이용자가 쉽게 알 수 있도록 "몰"의 초기 서비스화면(전면)에 게시합니다. 다만, 약관의 내용은 이용자가 연결화면을 통하여 볼 수 있도록 할 수 있습니다.</p>
        <p>② "몰"은 이용자가 약관에 동의하기에 앞서 약관에 정하여져 있는 내용 중 청약철회·배송책임·환불조건 등과 같은 중요한 내용을 이용자가 이해할 수 있도록 별도의 연결화면 또는 팝업화면 등을 제공하여 이용자의 확인을 구하여야 합니다.</p>
        <p>③ "몰"은 전자상거래등에서의소비자보호에관한법률, 약관의규제에관한법률, 전자거래기본법, 전자서명법, 정보통신망이용촉진등에관한법률, 방문판매등에관한법률, 소비자보호법 등 관련법을 위배하지 않는 범위에서 이 약관을 개정할 수 있습니다.</p>
        <p>④ "몰"이 약관을 개정할 경우에는 적용일자 및 개정사유를 명시하여 현행약관과 함께 몰의 초기화면에 그 적용일자 7일이전부터 적용일자 전일까지 공지합니다. 다만, 이용자에게 불리하게 약관내용을 변경하는 경우에는 최소한 30일 이상의 사전 유예기간을 두고 공지합니다. 이 경우 "몰“은 개정전 내용과 개정후 내용을 명확하게 비교하여 이용자가 알기 쉽도록 표시합니다.</p>
        <p>⑤ "몰"이 약관을 개정할 경우에는 그 개정약관은 그 적용일자 이후에 체결되는 계약에만 적용되고 그 이전에 이미 체결된 계약에 대해서는 개정전의 약관조항이 그대로 적용됩니다. 다만 이미 계약을 체결한 이용자가 개정약관 조항의 적용을 받기를 원하는 뜻을 제3항에 의한 개정약관의 공지기간내에 "몰"에 송신하여 "몰"의 동의를 받은 경우에는 개정약관 조항이 적용됩니다.</p>
        <p>⑥ 이 약관에서 정하지 아니한 사항과 이 약관의 해석에 관하여는 전자상거래등에서의 소비자보호에 관한 법률, 약관의 규제 등에 관한 법률, 공정거래위원회가 정하는 전자상거래 등에서의 소비자보호지침 및 관계법령 또는 상관례에 따릅니다.</p>
      </div>

      <div>
        <h4 class="font-bold text-gray-900 text-base mb-2">제4조(서비스의 제공 및 변경)</h4>
        <p>① "몰"은 다음과 같은 업무를 수행합니다.</p>
        <ul class="list-disc pl-5 mb-2 space-y-1">
          <li>재화 또는 용역에 대한 정보 제공 및 구매계약의 체결</li>
          <li>구매계약이 체결된 재화 또는 용역의 배송</li>
          <li>기타 "몰"이 정하는 업무</li>
        </ul>
        <p>② "몰"은 재화 또는 용역의 품절 또는 기술적 사양의 변경 등의 경우에는 장차 체결되는 계약에 의해 제공할 재화 또는 용역의 내용을 변경할 수 있습니다. 이 경우에는 변경된 재화 또는 용역의 내용 및 제공일자를 명시하여 현재의 재화 또는 용역의 내용을 게시한 곳에 즉시 공지합니다.</p>
        <p>③ "몰"이 제공하기로 이용자와 계약을 체결한 서비스의 내용을 재화등의 품절 또는 기술적 사양의 변경 등의 사유로 변경할 경우에는 그 사유를 이용자에게 통지 가능한 주소로 즉시 통지합니다.</p>
        <p>④ 전항의 경우 "몰"은 이로 인하여 이용자가 입은 손해를 배상합니다. 다만, "몰"이 고의 또는 과실이 없음을 입증하는 경우에는 그러하지 아니합니다.</p>
      </div>

      <div>
        <h4 class="font-bold text-gray-900 text-base mb-2">제5조(서비스의 중단)</h4>
        <p>① "몰"은 컴퓨터 등 정보통신설비의 보수점검·교체 및 고장, 통신의 두절 등의 사유가 발생한 경우에는 서비스의 제공을 일시적으로 중단할 수 있습니다.</p>
        <p>② "몰"은 제1항의 사유로 서비스의 제공이 일시적으로 중단됨으로 인하여 이용자 또는 제3자가 입은 손해에 대하여 배상합니다. 단, "몰"이 고의 또는 과실이 없음을 입증하는 경우에는 그러하지 아니합니다.</p>
        <p>③ 사업종목의 전환, 사업의 포기, 업체간의 통합 등의 이유로 서비스를 제공할 수 없게 되는 경우에는 "몰"은 제8조에 정한 방법으로 이용자에게 통지하고 당초 "몰"에서 제시한 조건에 따라 소비자에게 보상합니다. 다만, "몰"이 보상기준 등을 고지하지 아니한 경우에는 이용자들의 마일리지 또는 적립금 등을 "몰"에서 통용되는 통화가치에 상응하는 현물 또는 현금으로 이용자에게 지급합니다.</p>
      </div>

      <div>
        <h4 class="font-bold text-gray-900 text-base mb-2">제6조(회원가입)</h4>
        <p>① 이용자는 "몰"이 정한 가입 양식에 따라 회원정보를 기입한 후 이 약관에 동의한다는 의사표시를 함으로서 회원가입을 신청합니다.</p>
        <p>② "몰"은 제1항과 같이 회원으로 가입할 것을 신청한 이용자 중 다음 각호에 해당하지 않는 한 회원으로 등록합니다.</p>
        <ol class="list-decimal pl-5 mb-2 space-y-1">
          <li>가입신청자가 이 약관 제7조제3항에 의하여 이전에 회원자격을 상실한 적이 있는 경우, 다만 제7조제3항에 의한 회원자격 상실후 3년이 경과한 자로서 "몰"의 회원재가입 승낙을 얻은 경우에는 예외로 한다.</li>
          <li>등록 내용에 허위, 기재누락, 오기가 있는 경우</li>
          <li>기타 회원으로 등록하는 것이 "몰"의 기술상 현저히 지장이 있다고 판단되는 경우</li>
        </ol>
        <p>③ 회원가입계약의 성립시기는 "몰"의 승낙이 회원에게 도달한 시점으로 합니다.</p>
        <p>④ 회원은 제15조제1항에 의한 등록사항에 변경이 있는 경우, 즉시 전자우편 기타 방법으로 "몰"에 대하여 그 변경사항을 알려야 합니다.</p>
      </div>

      <div>
        <h4 class="font-bold text-gray-900 text-base mb-2">제7조(회원 탈퇴 및 자격 상실 등)</h4>
        <p>① 회원은 "몰"에 언제든지 탈퇴를 요청할 수 있으며 "몰"은 즉시 회원탈퇴를 처리합니다.</p>
        <p>② 회원이 다음 각호의 사유에 해당하는 경우, "몰"은 회원자격을 제한 및 정지시킬 수 있습니다.</p>
        <ol class="list-decimal pl-5 mb-2 space-y-1">
          <li>가입 신청시에 허위 내용을 등록한 경우</li>
          <li>"몰"을 이용하여 구입한 재화등의 대금, 기타 "몰"이용에 관련하여 회원이 부담하는 채무를 기일에 지급하지 않는 경우</li>
          <li>다른 사람의 "몰" 이용을 방해하거나 그 정보를 도용하는 등 전자상거래 질서를 위협하는 경우</li>
          <li>"몰"을 이용하여 법령 또는 이 약관이 금지하거나 공서양속에 반하는 행위를 하는 경우</li>
        </ol>
        <p>③ "몰"이 회원 자격을 제한·정지 시킨후, 동일한 행위가 2회이상 반복되거나 30일이내에 그 사유가 시정되지 아니하는 경우 "몰"은 회원자격을 상실시킬 수 있습니다.</p>
        <p>④ "몰"이 회원자격을 상실시키는 경우에는 회원등록을 말소합니다. 이 경우 회원에게 이를 통지하고, 회원등록 말소전에 최소한 30일 이상의 기간을 정하여 소명할 기회를 부여합니다.</p>
      </div>

      <div>
        <h4 class="font-bold text-gray-900 text-base mb-2">제8조(회원에 대한 통지)</h4>
        <p>① "몰"이 회원에 대한 통지를 하는 경우, 회원이 "몰"과 미리 약정하여 지정한 전자우편 주소로 할 수 있습니다.</p>
        <p>② "몰"은 불특정다수 회원에 대한 통지의 경우 1주일이상 "몰" 게시판에 게시함으로서 개별 통지에 갈음할 수 있습니다. 다만, 회원 본인의 거래와 관련하여 중대한 영향을 미치는 사항에 대하여는 개별통지를 합니다.</p>
      </div>

      <div>
        <h4 class="font-bold text-gray-900 text-base mb-2">제9조(구매신청)</h4>
        <p>"몰"이용자는 "몰"상에서 다음 또는 이와 유사한 방법에 의하여 구매를 신청하며, "몰"은 이용자가 구매신청을 함에 있어서 다음의 각 내용을 알기 쉽게 제공하여야 합니다. 단, 회원인 경우 제2호 내지 제4호의 적용을 제외할 수 있습니다.</p>
        <ol class="list-decimal pl-5 mb-2 space-y-1">
          <li>재화등의 검색 및 선택</li>
          <li>성명, 주소, 전화번호, 전자우편주소(또는 이동전화번호) 등의 입력</li>
          <li>약관내용, 청약철회권이 제한되는 서비스, 배송료·설치비 등의 비용부담과 관련한 내용에 대한 확인</li>
          <li>이 약관에 동의하고 위 3.호의 사항을 확인하거나 거부하는 표시(예, 마우스 클릭)</li>
          <li>재화등의 구매신청 및 이에 관한 확인 또는 "몰"의 확인에 대한 동의</li>
          <li>결제방법의 선택</li>
        </ol>
      </div>

      <div>
        <h4 class="font-bold text-gray-900 text-base mb-2">제10조 (계약의 성립)</h4>
        <p>① "몰"은 제9조와 같은 구매신청에 대하여 다음 각호에 해당하면 승낙하지 않을 수 있습니다. 다만, 미성년자와 계약을 체결하는 경우에는 법정대리인의 동의를 얻지 못하면 미성년자 본인 또는 법정대리인이 계약을 취소할 수 있다는 내용을 고지하여야 합니다.</p>
        <ol class="list-decimal pl-5 mb-2 space-y-1">
          <li>신청 내용에 허위, 기재누락, 오기가 있는 경우</li>
          <li>미성년자가 담배, 주류등 청소년보호법에서 금지하는 재화 및 용역을 구매하는 경우</li>
          <li>기타 구매신청에 승낙하는 것이 "몰" 기술상 현저히 지장이 있다고 판단하는 경우</li>
        </ol>
        <p>② "몰"의 승낙이 제12조제1항의 수신확인통지형태로 이용자에게 도달한 시점에 계약이 성립한 것으로 봅니다.</p>
        <p>③ "몰"의 승낙의 의사표시에는 이용자의 구매 신청에 대한 확인 및 판매가능 여부, 구매신청의 정정 취소등에 관한 정보등을 포함하여야 합니다.</p>
      </div>

      <div>
        <h4 class="font-bold text-gray-900 text-base mb-2">제11조(지급방법)</h4>
        <p>"몰"에서 구매한 재화 또는 용역에 대한 대금지급방법은 다음 각호의 방법중 가용한 방법으로 할 수 있습니다. 단, "몰"은 이용자의 지급방법에 대하여 재화 등의 대금에 어떠한 명목의 수수료도 추가하여 징수할 수 없습니다.</p>
        <ol class="list-decimal pl-5 mb-2 space-y-1">
          <li>폰뱅킹, 인터넷뱅킹, 메일 뱅킹 등의 각종 계좌이체</li>
          <li>선불카드, 직불카드, 신용카드 등의 각종 카드 결제</li>
          <li>온라인무통장입금</li>
          <li>전자화폐에 의한 결제</li>
          <li>수령시 대금지급</li>
          <li>마일리지 등 "몰"이 지급한 포인트에 의한 결제</li>
          <li>"몰"과 계약을 맺었거나 "몰"이 인정한 상품권에 의한 결제</li>
          <li>기타 전자적 지급 방법에 의한 대금 지급 등</li>
        </ol>
      </div>

      <div>
        <h4 class="font-bold text-gray-900 text-base mb-2">제12조(수신확인통지·구매신청 변경 및 취소)</h4>
        <p>① "몰"은 이용자의 구매신청이 있는 경우 이용자에게 수신확인통지를 합니다.</p>
        <p>② 수신확인통지를 받은 이용자는 의사표시의 불일치등이 있는 경우에는 수신확인통지를 받은 후 즉시 구매신청 변경 및 취소를 요청할 수 있고 "몰"은 배송전에 이용자의 요청이 있는 경우에는 지체없이 그 요청에 따라 처리하여야 합니다. 다만 이미 대금을 지불한 경우에는 제15조의 청약철회 등에 관한 규정에 따릅니다.</p>
      </div>

      <div>
        <h4 class="font-bold text-gray-900 text-base mb-2">제13조(재화등의 공급)</h4>
        <p>① "몰"은 이용자와 재화등의 공급시기에 관하여 별도의 약정이 없는 이상, 이용자가 청약을 한 날부터 7일 이내에 재화 등을 배송할 수 있도록 주문제작, 포장 등 기타의 필요한 조치를 취합니다. 다만, "몰"이 이미 재화 등의 대금의 전부 또는 일부를 받은 경우에는 대금의 전부 또는 일부를 받은 날부터 2영업일 이내에 조치를 취합니다. 이때 "몰"은 이용자가 재화등의 공급 절차 및 진행 사항을 확인할 수 있도록 적절한 조치를 합니다.</p>
        <p>② "몰"은 이용자가 구매한 재화에 대해 배송수단, 수단별 배송비용 부담자, 수단별 배송기간 등을 명시합니다. 만약 "몰"이 약정 배송기간을 초과한 경우에는 그로 인한 이용자의 손해를 배상하여야 합니다. 다만 "몰"이 고의·과실이 없음을 입증한 경우에는 그러하지 아니합니다.</p>
      </div>

      <div>
        <h4 class="font-bold text-gray-900 text-base mb-2">제14조(환급)</h4>
        <p>"몰"은 이용자가 구매신청한 재화등이 품절 등의 사유로 인도 또는 제공을 할 수 없을 때에는 지체없이 그 사유를 이용자에게 통지하고 사전에 재화 등의 대금을 받은 경우에는 대금을 받은 날부터 2영업일 이내에 환급하거나 환급에 필요한 조치를 취합니다.</p>
      </div>

      <div>
        <h4 class="font-bold text-gray-900 text-base mb-2">제15조(청약철회 등)</h4>
        <p>① "몰"과 재화등의 구매에 관한 계약을 체결한 이용자는 수신확인의 통지를 받은 날부터 7일 이내에는 청약의 철회를 할 수 있습니다.</p>
        <p>② 이용자는 재화등을 배송받은 경우 다음 각호의 1에 해당하는 경우에는 반품 및 교환을 할 수 없습니다.</p>
        <ol class="list-decimal pl-5 mb-2 space-y-1">
          <li>이용자에게 책임 있는 사유로 재화 등이 멸실 또는 훼손된 경우(다만, 재화 등의 내용을 확인하기 위하여 포장 등을 훼손한 경우에는 청약철회를 할 수 있습니다)</li>
          <li>이용자의 사용 또는 일부 소비에 의하여 재화 등의 가치가 현저히 감소한 경우</li>
          <li>시간의 경과에 의하여 재판매가 곤란할 정도로 재화등의 가치가 현저히 감소한 경우</li>
          <li>같은 성능을 지닌 재화등으로 복제가 가능한 경우 그 원본인 재화 등의 포장을 훼손한 경우</li>
        </ol>
        <p>③ 제2항제2호 내지 제4호의 경우에 "몰"이 사전에 청약철회 등이 제한되는 사실을 소비자가 쉽게 알 수 있는 곳에 명기하거나 시용상품을 제공하는 등의 조치를 하지 않았다면 이용자의 청약철회등이 제한되지 않습니다.</p>
        <p>④ 이용자는 제1항 및 제2항의 규정에 불구하고 재화등의 내용이 표시·광고 내용과 다르거나 계약내용과 다르게 이행된 때에는 당해 재화등을 공급받은 날부터 3월이내, 그 사실을 안 날 또는 알 수 있었던 날부터 30일 이내에 청약철회 등을 할 수 있습니다.</p>
      </div>

      <div>
        <h4 class="font-bold text-gray-900 text-base mb-2">제16조(청약철회 등의 효과)</h4>
        <p>① "몰"은 이용자로부터 재화 등을 반환받은 경우 3영업일 이내에 이미 지급받은 재화등의 대금을 환급합니다. 이 경우 "몰"이 이용자에게 재화등의 환급을 지연한 때에는 그 지연기간에 대하여 공정거래위원회가 정하여 고시하는 지연이자율을 곱하여 산정한 지연이자를 지급합니다.</p>
        <p>② "몰"은 위 대금을 환급함에 있어서 이용자가 신용카드 또는 전자화폐 등의 결제수단으로 재화등의 대금을 지급한 때에는 지체없이 당해 결제수단을 제공한 사업자로 하여금 재화등의 대금의 청구를 정지 또는 취소하도록 요청합니다.</p>
        <p>③ 청약철회등의 경우 공급받은 재화등의 반환에 필요한 비용은 이용자가 부담합니다. "몰"은 이용자에게 청약철회등을 이유로 위약금 또는 손해배상을 청구하지 않습니다. 다만 재화등의 내용이 표시·광고 내용과 다르거나 계약내용과 다르게 이행되어 청약철회등을 하는 경우 재화등의 반환에 필요한 비용은 "몰"이 부담합니다.</p>
        <p>④ 이용자가 재화등을 제공받을때 발송비를 부담한 경우에 "몰"은 청약철회시 그 비용을 누가 부담하는지를 이용자가 알기 쉽도록 명확하게 표시합니다.</p>
      </div>

      <div>
        <h4 class="font-bold text-gray-900 text-base mb-2">제17조(개인정보보호)</h4>
        <p>① "몰"은 이용자의 정보수집시 구매계약 이행에 필요한 최소한의 정보를 수집합니다. 다음 사항을 필수사항으로 하며 그 외 사항은 선택사항으로 합니다.</p>
        <ol class="list-decimal pl-5 mb-2 space-y-1">
          <li>성명</li>
          <li>주소</li>
          <li>전화번호</li>
          <li>희망ID(회원의 경우)</li>
          <li>비밀번호(회원의 경우)</li>
          <li>전자우편주소(또는 이동전화번호)</li>
        </ol>
        <p>② "몰"이 이용자의 개인식별이 가능한 개인정보를 수집하는 때에는 반드시 당해 이용자의 동의를 받습니다.</p>
        <p>③ 제공된 개인정보는 당해 이용자의 동의없이 목적외의 이용이나 제3자에게 제공할 수 없으며, 이에 대한 모든 책임은 몰이 집니다. 다만, 다음의 경우에는 예외로 합니다.</p>
        <ol class="list-decimal pl-5 mb-2 space-y-1">
          <li>배송업무상 배송업체에게 배송에 필요한 최소한의 이용자의 정보(성명, 주소, 전화번호)를 알려주는 경우</li>
          <li>통계작성, 학술연구 또는 시장조사를 위하여 필요한 경우로서 특정 개인을 식별할 수 없는 형태로 제공하는 경우</li>
          <li>재화등의 거래에 따른 대금정산을 위하여 필요한 경우</li>
          <li>도용방지를 위하여 본인확인에 필요한 경우</li>
          <li>법률의 규정 또는 법률에 의하여 필요한 불가피한 사유가 있는 경우</li>
        </ol>
        <p>④ "몰"이 제2항과 제3항에 의해 이용자의 동의를 받아야 하는 경우에는 개인정보 보호책임자의 신원(소속, 성명 및 전화번호, 기타 연락처), 정보의 수집목적 및 이용목적, 제3자에 대한 정보제공 관련사항(제공받은자, 제공목적 및 제공할 정보의 내용) 등 정보통신망이용촉진등에관한법률 제22조제2항이 규정한 사항을 미리 명시하거나 고지해야 하며 이용자는 언제든지 이 동의를 철회할 수 있습니다.</p>
        <p>⑤ 이용자는 언제든지 "몰"이 가지고 있는 자신의 개인정보에 대해 열람 및 오류정정을 요구할 수 있으며 "몰"은 이에 대해 지체없이 필요한 조치를 취할 의무를 집니다. 이용자가 오류의 정정을 요구한 경우에는 "몰"은 그 오류를 정정할 때까지 당해 개인정보를 이용하지 않습니다.</p>
        <p>⑥ "몰"은 개인정보 보호를 위하여 관리자를 한정하여 그 수를 최소화하며 신용카드, 은행계좌 등을 포함한 이용자의 개인정보의 분실, 도난, 유출, 변조 등으로 인한 이용자의 손해에 대하여 모든 책임을 집니다.</p>
        <p>⑦ "몰" 또는 그로부터 개인정보를 제공받은 제3자는 개인정보의 수집목적 또는 제공받은 목적을 달성한 때에는 당해 개인정보를 지체없이 파기합니다.</p>
      </div>

      <div>
        <h4 class="font-bold text-gray-900 text-base mb-2">제18조(“몰“의 의무)</h4>
        <p>① "몰"은 법령과 이 약관이 금지하거나 공서양속에 반하는 행위를 하지 않으며 이 약관이 정하는 바에 따라 지속적이고, 안정적으로 재화·용역을 제공하는데 최선을 다하여야 합니다.</p>
        <p>② "몰"은 이용자가 안전하게 인터넷 서비스를 이용할 수 있도록 이용자의 개인정보(신용정보 포함)보호를 위한 보안 시스템을 갖추어야 합니다.</p>
        <p>③ "몰"이 상품이나 용역에 대하여 「표시·광고의공정화에관한법률」 제3조 소정의 부당한 표시·광고행위를 함으로써 이용자가 손해를 입은 때에는 이를 배상할 책임을 집니다.</p>
        <p>④ "몰"은 이용자가 원하지 않는 영리목적의 광고성 전자우편을 발송하지 않습니다.</p>
      </div>

      <div>
        <h4 class="font-bold text-gray-900 text-base mb-2">제19조(회원의 ID 및 비밀번호에 대한 의무)</h4>
        <p>① 제17조의 경우를 제외한 ID와 비밀번호에 관한 관리책임은 회원에게 있습니다.</p>
        <p>② 회원은 자신의 ID 및 비밀번호를 제3자에게 이용하게 해서는 안됩니다.</p>
        <p>③ 회원이 자신의 ID 및 비밀번호를 도난당하거나 제3자가 사용하고 있음을 인지한 경우에는 바로 "몰"에 통보하고 "몰"의 안내가 있는 경우에는 그에 따라야 합니다.</p>
      </div>

      <div>
        <h4 class="font-bold text-gray-900 text-base mb-2">제20조(이용자의 의무)</h4>
        <p>이용자는 다음 행위를 하여서는 안됩니다.</p>
        <ol class="list-decimal pl-5 mb-2 space-y-1">
          <li>신청 또는 변경시 허위 내용의 등록</li>
          <li>타인의 정보 도용</li>
          <li>"몰"에 게시된 정보의 변경</li>
          <li>"몰"이 정한 정보 이외의 정보(컴퓨터 프로그램 등) 등의 송신 또는 게시</li>
          <li>"몰" 기타 제3자의 저작권 등 지적재산권에 대한 침해</li>
          <li>"몰" 기타 제3자의 명예를 손상시키거나 업무를 방해하는 행위</li>
          <li>외설 또는 폭력적인 메시지, 화상, 음성, 기타 공서양속에 반하는 정보를 몰에 공개 또는 게시하는 행위</li>
        </ol>
      </div>

      <div>
        <h4 class="font-bold text-gray-900 text-base mb-2">제21조(연결"몰"과 피연결"몰" 간의 관계)</h4>
        <p>① 상위 "몰"과 하위 "몰"이 하이퍼 링크(예: 하이퍼 링크의 대상에는 문자, 그림 및 동화상 등이 포함됨)방식 등으로 연결된 경우, 전자를 연결 "몰"(웹 사이트)이라고 하고 후자를 피연결 "몰"(웹사이트)이라고 합니다.</p>
        <p>② 연결"몰"은 피연결"몰"이 독자적으로 제공하는 재화등에 의하여 이용자와 행하는 거래에 대해서 보증책임을 지지 않는다는 뜻을 연결"몰"의 초기화면 또는 연결되는 시점의 팝업화면으로 명시한 경우에는 그 거래에 대한 보증책임을 지지 않습니다.</p>
      </div>

      <div>
        <h4 class="font-bold text-gray-900 text-base mb-2">제22조(저작권의 귀속 및 이용제한)</h4>
        <p>① “몰“이 작성한 저작물에 대한 저작권 기타 지적재산권은 ”몰“에 귀속합니다.</p>
        <p>② 이용자는 "몰"을 이용함으로써 얻은 정보 중 "몰"에게 지적재산권이 귀속된 정보를 "몰"의 사전 승낙없이 복제, 송신, 출판, 배포, 방송 기타 방법에 의하여 영리목적으로 이용하거나 제3자에게 이용하게 하여서는 안됩니다.</p>
        <p>③ "몰"은 약정에 따라 이용자에게 귀속된 저작권을 사용하는 경우 당해 이용자에게 통보하여야 합니다.</p>
      </div>

      <div>
        <h4 class="font-bold text-gray-900 text-base mb-2">제23조(분쟁해결)</h4>
        <p>① "몰"은 이용자가 제기하는 정당한 의견이나 불만을 반영하고 그 피해를 보상처리하기 위하여 피해보상처리기구를 설치·운영합니다.</p>
        <p>② "몰"은 이용자로부터 제출되는 불만사항 및 의견은 우선적으로 그 사항을 처리합니다. 다만, 신속한 처리가 곤란한 경우에는 이용자에게 그 사유와 처리일정을 즉시 통보해 드립니다.</p>
        <p>③ "몰"과 이용자간에 발생한 전자상거래 분쟁과 관련하여 이용자의 피해구제신청이 있는 경우에는 공정거래위원회 또는 시·도지사가 의뢰하는 분쟁조정기관의 조정에 따를 수 있습니다.</p>
      </div>

      <div>
        <h4 class="font-bold text-gray-900 text-base mb-2">제24조(재판권 및 준거법)</h4>
        <p>① "몰"과 이용자간에 발생한 전자상거래 분쟁에 관한 소송은 제소 당시의 이용자의 주소에 의하고, 주소가 없는 경우에는 거소를 관할하는 지방법원의 전속관할로 합니다. 다만, 제소 당시 이용자의 주소 또는 거소가 분명하지 않거나 외국 거주자의 경우에는 민사소송법상의 관할법원에 제기합니다.</p>
        <p>② "몰"과 이용자간에 제기된 전자상거래 소송에는 한국법을 적용합니다.</p>
      </div>

      <div class="mt-8 border-t border-gray-100 pt-4">
        <h4 class="font-bold text-gray-900 text-base mb-2">부칙</h4>
        <p>1. 이 약관은 2026년 1월 15일부터 적용됩니다.</p>
      </div>
    </div>
  `;

  const privacyContent = `
    <div class="space-y-6 text-gray-600 text-sm leading-relaxed">
      <p class="mb-4">메이커스토리 쇼핑몰은 이용자의 개인정보를 보호하고 이와 관련한 고충을 신속하고 원활하게 처리할 수 있도록 다음과 같이 개인정보 처리방침을 수립·공개하며, 본 개인정보 처리방침을 홈페이지 첫 화면에 공개함으로써 이용자들이 언제나 용이하게 보실 수 있도록 조치하고 있습니다. 개인정보 처리방침은 정부의 법률 및 지침 변경이나 회사의 내부 방침 변경 등으로 인하여 수시로 변경될 수 있고, 이에 따른 개인정보 처리방침의 지속적인 개선을 위하여 필요한 절차를 정하고 있습니다. 이용자들께서는 사이트 방문 시 수시로 확인하시기 바랍니다.</p>
      
      <div>
        <h4 class="font-bold text-gray-900 text-base mb-2">1. 개인정보 수집에 대한 동의</h4>
        <p>메이커스토리 쇼핑몰은 이용자들이 회사의 개인정보수집이용 동의 또는 이용약관의 내용에 대하여 「동의」버튼 또는 「취소」버튼을 클릭할 수 있는 절차를 마련하여, 「동의」버튼을 클릭하면 개인정보 수집에 대해 동의한 것으로 봅니다.</p>
      </div>

      <div>
        <h4 class="font-bold text-gray-900 text-base mb-2">2. 수집하는 개인정보의 항목 및 수집방법</h4>
        <p class="font-bold mt-2 text-gray-700">가. 수집 항목</p>
        <p>메이커스토리 쇼핑몰은 이용자들이 회원서비스를 이용하기 위해 회원으로 가입하실 때 서비스 제공을 위한 필수/선택적인 정보들을 온라인상에서 입력 받고 있습니다.</p>
        <ul class="list-disc pl-5 mb-2 space-y-1 mt-1">
          <li>회원 가입 시에 받는 필수적인 정보 : 이름, 이메일 주소, 연락처, 배송지 주소</li>
          <li>회원제 서비스 이용에 따른 본인 확인 절차에 이용 시 수집 정보 : 아이디, 비밀번호</li>
          <li>자동 로그인 이용을 위한 본인 확인 정보 수집 : 아이디 , 암호화된 비밀번호</li>
          <li>서비스 및 부가 서비스 이용에 대한 요금 결제 시 수집하는 정보 : 은행계좌정보, 신용카드정보</li>
          <li>14세미만 가입자의 경우 법정대리인의 정보</li>
          <li>기타 양질의 서비스 제공을 위하여 선택적으로 수집하는 정보 : 전화번호, 기타</li>
        </ul>
        <p>또한, 서비스 이용 과정에서 서비스 제공을 위해 자동으로 수집하는 정보가 있을 수 있으며, 이와 같이 수집된 정보는 개인정보와의 연계 등에 따라 개인정보에 해당할 수 있고, 개인정보에 해당하지 않을 수도 있습니다.</p>
        <ul class="list-disc pl-5 mb-2 space-y-1 mt-1">
          <li>통계 수집을 위한 회원가입, 방문자, 주문자, 게시글 작성 시 생성 정보 : IP Address , 브라우저 정보, OS정보, 서비스 이용 기록, 유입경로, 나이, 배송지역, 성별, 아이디 (이메일)</li>
          <li>불량회원의 부정 이용 방지와 비인가 사용 방지를 위해 수집하는 정보 : IP Address</li>
          <li>회원 CS처리 및 회원 관리를 위한 수정 이전 정보 : 이름, 이메일, 전화번호, 주소, 성별, 생일 등</li>
          <li>그 외 서비스 제공을 위해 자동으로 수집하고 있는 정보 : 쿠키</li>
        </ul>
        
        <p class="font-bold mt-2 text-gray-700">나. 수집 방법</p>
        <p>메이커스토리 쇼핑몰은 다음과 같은 방법으로 개인정보를 수집합니다.</p>
        <ul class="list-disc pl-5 mb-2 space-y-1 mt-1">
          <li>홈페이지, 모바일기기, 서면양식, 팩스, 전화, 상담 게시판, 이메일, 이벤트 응모, 배송요청</li>
          <li>고객 동의 및 고객 입력을 통한 정보 수집</li>
          <li>협력회사로부터의 제공</li>
          <li>생성정보 수집 툴을 통한 수집</li>
        </ul>

        <p class="font-bold mt-2 text-gray-700">다. 기타</p>
        <p>쇼핑몰 내에서의 설문조사나 이벤트 행사 시 통계분석이나 경품제공 등을 위해 선별적으로 개인정보 입력을 요청할 수 있습니다. 그러나, 이용자의 기본적 인권 침해의 우려가 있는 민감한 개인정보(인종 및 민족, 사상 및 신조, 출신지 및 본적지, 정치적 성향 및 범죄기록, 건강상태 및 성생활 등)는 수집하지 않으며 부득이하게 수집해야 할 경우 이용자들의 사전동의를 반드시 구할 것입니다.</p>
      </div>

      <div>
        <h4 class="font-bold text-gray-900 text-base mb-2">3. 개인정보의 수집 및 이용 목적</h4>
        <p>메이커스토리 쇼핑몰은 이용자의 사전 동의 없이는 이용자의 개인 정보를 수집하지 않으며, 수집된 정보는 아래와 같이 이용하고 있습니다.</p>
        <p class="font-bold mt-2 text-gray-700">가. 신규 서비스의 개발</p>
        <p>이용자들이 제공한 개인정보를 바탕으로 보다 더 유용한 서비스를 개발할 수 있습니다. 회사는 신규 서비스 개발이나 컨텐츠의 확충 시에 기존 이용자들이 회사에 제공한 개인정보를 바탕으로 개발해야 할 서비스의 우선 순위를 보다 더 효율적으로 정하고, 회사는 이용자들이 필요로 할 컨텐츠를 합리적으로 선택하여 제공할 수 있습니다.</p>
        <p class="font-bold mt-2 text-gray-700">나. 회원관리</p>
        <p>회원제 서비스 이용에 따른 본인확인, 개인 식별, 불량회원의 부정 이용 방지와 비인가 사용 방지, 가입 의사 확인, 연령확인, 주문 및 결제처리, 배송처리, 만14세 미만 아동 개인정보 수집 시 법정 대리인 동의여부 확인, 불만처리 등 민원처리, 고지사항 전달</p>
        <p class="font-bold mt-2 text-gray-700">다. 마케팅 및 광고에 활용</p>
        <p>신규 서비스 개발과 이벤트 행사에 따른 정보 전달 및 맞춤 서비스 제공, 인구통계학적 특성에 따른 서비스 제공 및 광고 게재, 접속 빈도 파악 또는 회원의 서비스 이용에 대한 통계</p>
      </div>

      <div>
        <h4 class="font-bold text-gray-900 text-base mb-2">4. 수집하는 개인정보의 보유 및 이용기간</h4>
        <p>메이커스토리 쇼핑몰은 이용자의 개인정보를 원칙적으로 개인정보의 수집 및 이용목적이 달성되면 지체 없이 파기합니다. 단, 다음의 정보에 대해서는 아래의 이유로 명시한 기간 동안 보존합니다.</p>
        <p class="font-bold mt-2 text-gray-700">가. 관련법령에 의한 정보보유 사유</p>
        <ul class="list-disc pl-5 mb-2 space-y-1 mt-1">
          <li>계약 또는 청약철회 등에 관한 기록 : 5년 (전자상거래등에서의 소비자보호에 관한 법률)</li>
          <li>대금결제 및 재화 등의 공급에 관한 기록 : 5년 (전자상거래등에서의 소비자보호에 관한 법률)</li>
          <li>소비자의 불만 또는 분쟁처리에 관한 기록 : 3년 (전자상거래등에서의 소비자보호에 관한 법률)</li>
          <li>방문(로그)에 관한 기록 : 3개월(통신비밀보호법)</li>
        </ul>
      </div>

      <div>
        <h4 class="font-bold text-gray-900 text-base mb-2">5. 개인정보의 파기 절차 및 방법</h4>
        <p>메이커스토리 쇼핑몰은 귀중한 회원의 개인정보를 안전하게 처리하며, 유출의 방지를 위하여 다음과 같은 방법을 통하여 개인정보를 파기합니다.</p>
        <p class="font-bold mt-2 text-gray-700">가. 파기절차</p>
        <p>이용자가 서비스 이용 등을 위해 입력하신 정보는 목적이 달성된 후 별도의 DB로 옮겨져(종이의 경우 별도의 서류함) 내부 방침 및 기타 관련 법령에 의한 정보보호 사유에 따라(보유 및 이용기간 참조) 일정 기간 저장된 후 파기됩니다. 별도 DB로 옮겨진 개인정보는 법률에 의한 경우가 아니고서는 보유되어지는 이외의 다른 목적으로 이용되지 않습니다.</p>
        <p class="font-bold mt-2 text-gray-700">나. 파기방법</p>
        <ul class="list-disc pl-5 mb-2 space-y-1 mt-1">
          <li>종이에 출력된 개인정보 : 분쇄기로 분쇄하거나 소각</li>
          <li>전자적 파일 형태로 저장된 개인정보 : 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제</li>
        </ul>
      </div>

      <div>
        <h4 class="font-bold text-gray-900 text-base mb-2">6. 수집한 개인정보의 공유 및 제공</h4>
        <p>메이커스토리 쇼핑몰은 이용자들의 개인정보를 동의받은 범위 내에서 사용하며, 이용자의 사전 동의 없이는 동 범위를 초과하여 이용하거나 원칙적으로 이용자의 개인정보를 외부에 공유 및 제공하지 않습니다. 다만, 아래의 경우에는 예외로 합니다.</p>
        <ul class="list-disc pl-5 mb-2 space-y-1 mt-1">
          <li>이용자들이 사전에 공유 및 제공에 동의한 경우</li>
          <li>서비스 제공에 따른 요금정산을 위하여 필요한 경우</li>
          <li>법령의 규정에 의거하거나, 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우</li>
        </ul>
      </div>

      <div>
        <h4 class="font-bold text-gray-900 text-base mb-2">7. 이용자 자신의 개인정보 관리(열람,정정,삭제 등)에 관한 사항</h4>
        <p>회원님이 원하실 경우 언제라도 당사에서 개인정보를 열람하실 수 있으며 보관된 필수 정보를 수정하실 수 있습니다. 또한 회원 가입 시 요구된 필수 정보 외의 추가 정보는 언제나 열람, 수정, 삭제할 수 있습니다. 회원님의 개인정보 변경 및 삭제와 회원탈퇴는 당사의 고객센터에서 로그인(Login) 후 이용하실 수 있습니다.</p>
      </div>

      <div>
        <h4 class="font-bold text-gray-900 text-base mb-2">8. 쿠키(Cookie)의 운용 및 거부</h4>
        <p class="font-bold mt-2 text-gray-700">가. 쿠키의 사용 목적</p>
        <p>① 회사는 개인 맞춤 서비스를 제공하기 위해서 이용자에 대한 정보를 저장하고 수시로 불러오는 '쿠키(cookie)'를 사용합니다. 쿠키는 웹사이트 서버가 이용자의 브라우저에게 전송하는 소량의 정보로서 이용자 컴퓨터의 하드디스크에 저장됩니다.</p>
        <p>② 회사는 쿠키의 사용을 통해서만 가능한 특정된 맞춤형 서비스를 제공할 수 있습니다.</p>
        <p>③ 회사는 회원을 식별하고 회원의 로그인 상태를 유지하기 위해 쿠키를 사용할 수 있습니다.</p>
        
        <p class="font-bold mt-2 text-gray-700">나. 쿠키의 설치/운용 및 거부</p>
        <p>① 이용자는 쿠키 설치에 대한 선택권을 가지고 있습니다. 따라서 이용자는 웹브라우저에서 옵션을 조정함으로써 모든 쿠키를 허용/거부하거나, 쿠키가 저장될 때마다 확인을 거치도록 할 수 있습니다.</p>
        <p>② 쿠키의 저장을 거부할 경우에는 개인 맞춤서비스 등 회사가 제공하는 일부 서비스는 이용이 어려울 수 있습니다.</p>
      </div>

      <div>
        <h4 class="font-bold text-gray-900 text-base mb-2">9. 개인정보의 위탁처리</h4>
        <p>메이커스토리 쇼핑몰은 개인정보의 처리와 관련하여 아래와 같이 업무를 위탁하고 있으며, 관계 법령에 따라 위탁계약 시 개인정보가 안전하게 관리될 수 있도록 필요한 사항을 규정하고 있습니다. 또한 위탁하는 정보는 당해 목적을 달성하기 위하여 필요한 최소한의 정보에 국한됩니다.</p>
      </div>

      <div>
        <h4 class="font-bold text-gray-900 text-base mb-2">10. 개인정보보호를 위한 기술적/관리적 대책</h4>
        <p>메이커스토리 쇼핑몰은 이용자의 개인정보를 처리함에 있어 개인정보가 분실, 도난, 유출, 변조, 또는 훼손되지 않도록 안전성 확보를 위하여 다음과 같은 관리적, 기술적, 물리적 대책을 강구하고 있습니다.</p>
        <p class="font-bold mt-2 text-gray-700">가. 관리적 조치</p>
        <p>내부관리계획 수립. 시행, 정기적 직원 교육 등</p>
        <p class="font-bold mt-2 text-gray-700">나. 기술적 조치</p>
        <p>개인정보처리시스템 등의 접근권한 관리, 접근통제시스템 설치, 고유식별정보 등의 암호화, 보안프로그램 설치</p>
        <p class="font-bold mt-2 text-gray-700">다. 물리적 조치</p>
        <p>전산실, 자료보관실 등의 접근통제</p>
        <p class="mt-2 text-xs text-gray-500">메이커스토리 쇼핑몰은 는 이용자 개인의 실수나 기본적인 인터넷의 위험성 때문에 일어나는 일들에 대해 책임을 지지 않습니다. 이용자 개개인이 본인의 개인정보를 보호하기 위해서 자신의 아이디(ID) 와 비밀번호를 적절하게 관리하고 이에 대한 책임을 져야 합니다.</p>
      </div>

      <div>
        <h4 class="font-bold text-gray-900 text-base mb-2">11. 개인정보 관련 의견수렴 및 불만처리에 관한 사항</h4>
        <p>메이커스토리 쇼핑몰은 개인정보보호와 관련하여 이용자 여러분들의 의견을 수렴하고 있으며 불만을 처리하기 위하여 모든 절차와 방법을 마련하고 있습니다. 이용자들은 하단에 명시한 "12. 개인정보 관리책임자 및 담당자의 소속-성명 및 연락처"항을 참고하여 전화나 메일을 통하여 불만사항을 신고할 수 있고, 메이커스토리 쇼핑몰은 이용자들의 신고사항에 대하여 신속하고도 충분한 답변을 해 드릴 것입니다.</p>
      </div>

      <div>
        <h4 class="font-bold text-gray-900 text-base mb-2">12. 개인정보 보호책임자 및 담당자의 소속-성명 및 연락처</h4>
        <p>메이커스토리 쇼핑몰은 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 이용자의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.</p>
        <div class="mt-4 p-4 bg-gray-50 rounded-xl text-sm border border-gray-100 shadow-sm">
          <p class="mb-1"><span class="font-bold text-gray-900 w-24 inline-block">이름</span> 김향란</p>
          <p class="mb-1"><span class="font-bold text-gray-900 w-24 inline-block">소속 / 직위</span> 대표</p>
          <p class="mb-1"><span class="font-bold text-gray-900 w-24 inline-block">E-MAIL</span> seven_iris@naver.com</p>
          <p><span class="font-bold text-gray-900 w-24 inline-block">전화번호</span> 053-811-8922</p>
        </div>
      </div>

      <div>
        <h4 class="font-bold text-gray-900 text-base mb-2">13. 이용자 및 법정대리인의 권리와 그 행사방법</h4>
        <p>가. 이용자 및 법정 대리인은 언제든지 등록되어 있는 자신 혹은 당해 만 14세 미만 아동의 개인정보를 조회하거나 수정할 수 있으며 가입해지(동의철회)를 요청할 수도 있습니다.</p>
        <p>나. 이용자 혹은 만 14세 미만 아동의 개인정보 조회, 수정을 위해서는 로그인 후 MyPage에서 ‘개인정보변경’(또는 ‘회원정보수정’ 등)을, 가입해지(동의철회)를 위해서는 "회원탈퇴"를 클릭하여 본인 확인 절차를 거치신 후 직접 열람, 정정 또는 탈퇴가 가능합니다. 혹은 개인정보 보호책임자에게 서면, 전화 또는 이메일로 연락하시면 지체 없이 조치하겠습니다.</p>
        <p>다. 이용자가 개인정보의 오류에 대한 정정을 요청하신 경우에는 정정을 완료하기 전까지 당해 개인정보를 이용 또는 제공하지 않습니다. 또한 잘못된 개인정보를 제3자에게 이미 제공한 경우에는 정정 처리결과를 제3자에게 지체 없이 통지하여 정정이 이루어지도록 하겠습니다.</p>
        <p>라. 메이커스토리 쇼핑몰은 이용자 혹은 법정 대리인의 요청에 의해 해지 또는 삭제된 개인정보는 "수집하는 개인정보의 보유 및 이용기간"에 명시된 바에 따라 처리하고 그 외의 용도로 열람 또는 이용할 수 없도록 처리하고 있습니다.</p>
      </div>

      <div>
        <h4 class="font-bold text-gray-900 text-base mb-2">14. 권익침해 구제방법</h4>
        <p>이용자는 아래의 기관에 대해 개인정보 침해에 대한 피해구제, 상담 등을 문의하실 수 있습니다.</p>
        <p class="text-xs text-gray-400 mt-1 mb-2">&lt;아래의 기관은 회사와는 별개의 기관으로서, 회사의 자체적인 개인정보 불만처리, 피해구제 결과에 만족하지 못하시거나 보다 자세한 도움이 필요하시면 문의하여 주시기 바랍니다&gt;</p>
        <ul class="list-disc pl-5 mb-2 space-y-2 mt-2">
          <li><strong>개인정보 침해신고센터 (한국인터넷진흥원 운영)</strong><br/>소관업무: 개인정보 침해사실 신고, 상담 신청<br/>홈페이지: privacy.kisa.or.kr / 전화: 118<br/>주소 : (58324) 전남 나주시 진흥길 9(빛가람동 301-2) 3층 개인정보침해신고센터</li>
          <li><strong>개인정보 분쟁조정위원회</strong><br/>소관업무: 개인정보 분쟁조정신청, 집단분쟁조정 (민사적 해결)<br/>홈페이지: www.kopico.go.kr / 전화: 1833-6972<br/>주소 : (03171)서울특별시 종로구 세종대로 209 정부서울청사 4층</li>
          <li><strong>대검찰청 사이버수사과:</strong> http://www.spo.go.kr</li>
          <li><strong>경찰청 사이버안전국:</strong> http://cyberbureau.police.go.kr</li>
        </ul>
      </div>

      <div>
        <h4 class="font-bold text-gray-900 text-base mb-2">15. 고지의 의무</h4>
        <p>현 개인정보처리방침의 내용은 정부의 정책 또는 보안기술의 변경에 따라 내용의 추가 삭제 및 수정이 있을 시에는 홈페이지의 '공지사항'을 통해 고지할 것입니다.</p>
        <p class="mt-2 text-sm text-gray-500 font-medium bg-gray-50 p-2 rounded inline-block">개인정보처리방침 시행일자: 2026-1-15<br/>개인정보처리방침 변경일자: 2026-1-15</p>
      </div>
    </div>
  `;

  const content = type === 'agreement' ? agreementContent : privacyContent;

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center p-4 md:p-10 animate-in fade-in duration-200">
      <div 
        className="absolute inset-0 bg-black/60 backdrop-blur-sm"
        onClick={onClose}
      ></div>
      
      <div className="relative w-full max-w-2xl bg-white rounded-[32px] shadow-2xl overflow-hidden flex flex-col max-h-[85vh] animate-in zoom-in-95 duration-300 border border-gray-100">
        {/* Header */}
        <div className="p-6 md:p-8 border-b border-gray-100 flex justify-between items-center bg-gray-50/50">
          <h3 className="text-xl font-black text-gray-900 uppercase tracking-tight italic">{title}</h3>
          <button 
            onClick={onClose}
            className="p-2 bg-white rounded-full hover:bg-gray-100 transition shadow-sm border border-gray-100"
          >
            <svg className="w-5 h-5 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* Content */}
        <div className="flex-1 overflow-y-auto p-6 md:p-8 bg-white custom-scrollbar">
          <div 
            className="prose prose-sm prose-indigo max-w-none"
            dangerouslySetInnerHTML={{ __html: content }}
          />
        </div>

        {/* Footer */}
        <div className="p-5 border-t border-gray-100 bg-gray-50 flex justify-end">
          <button 
            onClick={onClose}
            className="px-8 py-3 bg-gray-900 text-white rounded-xl font-black text-xs hover:bg-indigo-600 transition shadow-lg"
          >
            확인
          </button>
        </div>
      </div>
      
      <style>{`
        .custom-scrollbar::-webkit-scrollbar {
          width: 6px;
        }
        .custom-scrollbar::-webkit-scrollbar-track {
          background: #f1f5f9;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb {
          background-color: #cbd5e1;
          border-radius: 20px;
        }
      `}</style>
    </div>
  );
};

export default PolicyModal;
